﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import * as nouislider from 'nouislider';

import * as FilePond from 'filepond';

import FilePondPluginFileEncode from '../../../plugins/filepond-plugin-file-encode';
import FilePondPluginFileValidateType from '../../../plugins/filepond-plugin-file-validate-type';

import tpl_eventApp from './tpl/eventApp.html';

import View_DialogWaiting2 from '../../../../lib/views/dialogWaiting2/dialogWaiting2';
import View_DialogWaiting from '../../../../lib/views/dialogWaiting/dialogWaiting';
import * as Entities_Empty from '../../../../lib/entities/empty';
import * as Entities_TmpCustomWebpageItem from '../../../entities/tmpCustomWebpageItem';
import * as Entities_Memory from '../../../entities/memory';

import config from '../../../../common/config';

export default Marionette.ItemView.extend({
    dialogRegion: '#eventApp_modal',
    errors: [],
    getTemplate: function () {
        return tpl_eventApp({ model: this.model.toJSON() });
    },
    initialize: function () {
        this.app = this.options.app;

        var self = this;

        //this.listenTo(this.model, 'change', this.render, this);

        this.menuItemCollection = new Entities_TmpCustomWebpageItem.Collection();
        var customWebpageItem = this.app.entities.collections.customWebpageItem.where({ EventId: this.options.parent.options.templateModel.attributes.EventId })
        customWebpageItem.forEach(function (entry) {
            var tmpModel = new Entities_TmpCustomWebpageItem.Model();
            //tmpModel.attributes.Webpage = entry.attributes.Webpage;
            tmpModel.attributes.EventId = entry.attributes.EventId;
            tmpModel.attributes.Name = entry.attributes.Name;
            tmpModel.attributes.Tag = entry.attributes.Tag;

            //NOBODYCHANGEtmpModel.attributes.Body = entry.attributes.Body.split('<p>&nbsp;</p>').join('');
            tmpModel.attributes.Body = entry.attributes.Body;
            tmpModel.attributes.OldBody = entry.attributes.Body;
            tmpModel.attributes.Checksum = '';
            tmpModel.attributes.BodyCK = '';
            tmpModel.attributes.BodyCB = '';
            tmpModel.attributes.Position = entry.attributes.Position;
            tmpModel.attributes.Duration = entry.attributes.Duration;
            tmpModel.attributes.Css = entry.attributes.Css;
            tmpModel.attributes.Status = entry.attributes.Status;
            tmpModel.attributes.id = entry.attributes.id;
            tmpModel.id = entry.id;
            tmpModel.attributes.orgId = entry.attributes.id;

            tmpModel.attributes.EnableDuration = false;
            tmpModel.attributes.DisplayType = 0;
            tmpModel.attributes.Parent = entry.attributes.Parent;
            tmpModel.attributes.Dropdown = entry.attributes.Dropdown;

            if (tmpModel.attributes.Tag == 1 && tmpModel.attributes.Position == 1) {
                tmpModel.attributes.Selected = true;
            } else {
                tmpModel.attributes.Selected = false;
            }

            self.menuItemCollection.add(tmpModel);
        });

        var tmpSelectedModelSetting = this.app.entities.collections.customModule.where({ EventId: this.options.parent.options.templateModel.attributes.EventId, ModuleType: 100 })[0];
        var data = JSON.parse(tmpSelectedModelSetting.attributes.Data);
        self.InfoPageSetting = new Entities_Memory.Model(data[0].Data);
        
    },
    ui: {
        'eventApp_input_File_Name': '#eventApp_input_File_Name',
        'eventApp_filePond': '#eventApp_filePond',
        'eventApp_dropDown_StartPage': '#eventApp_dropDown_StartPage',
        'eventApp_dropDown_EndPage': '#eventApp_dropDown_EndPage',
        'eventApp_checkbox_EnablePlay': '#eventApp_checkbox_EnablePlay',
        'eventApp_group_Duration_01': '#eventApp_group_Duration_01',
        'eventApp_input_Duration_01': '#eventApp_input_Duration_01',
        'eventApp_label_Duration_01': '#eventApp_label_Duration_01',
        'eventApp_group_Duration_02': '#eventApp_group_Duration_02',
        'eventApp_input_Duration_02': '#eventApp_input_Duration_02',
        'eventApp_label_Duration_02': '#eventApp_label_Duration_02',
        'eventApp_group_Duration_03': '#eventApp_group_Duration_03',
        'eventApp_input_Duration_03': '#eventApp_input_Duration_03',
        'eventApp_label_Duration_03': '#eventApp_label_Duration_03',
        'eventApp_group_Duration_04': '#eventApp_group_Duration_04',
        'eventApp_input_Duration_04': '#eventApp_input_Duration_04',
        'eventApp_label_Duration_04': '#eventApp_label_Duration_04',
        'eventApp_group_Duration_05': '#eventApp_group_Duration_05',
        'eventApp_input_Duration_05': '#eventApp_input_Duration_05',
        'eventApp_label_Duration_05': '#eventApp_label_Duration_05',
        'menuSingle_dropDown_MenuItem_01': '#menuSingle_dropDown_MenuItem_01',
        'menuSingle_dropDown_MenuItem_02': '#menuSingle_dropDown_MenuItem_02',
        'menuSingle_dropDown_MenuItem_03': '#menuSingle_dropDown_MenuItem_03',
        'menuSingle_dropDown_MenuItem_04': '#menuSingle_dropDown_MenuItem_04',
        'menuSingle_dropDown_MenuItem_05': '#menuSingle_dropDown_MenuItem_05',

        'eventApp_dropDown_MenuItem_01': '#eventApp_dropDown_Menuitem_01',
        'eventApp_dropDown_MenuItem_02': '#eventApp_dropDown_Menuitem_02',
        'eventApp_dropDown_MenuItem_03': '#eventApp_dropDown_Menuitem_03',
        'eventApp_dropDown_MenuItem_04': '#eventApp_dropDown_Menuitem_04',
        'eventApp_dropDown_MenuItem_05': '#eventApp_dropDown_Menuitem_05',
        'module_input_ModuleMargin_Top': '#module_input_ModuleMargin_Top',
        'module_input_ModuleMargin_Bottom': '#module_input_ModuleMargin_Bottom',
        'module_input_ModuleMargin_Left': '#module_input_ModuleMargin_Left',
        'module_input_ModuleMargin_Right': '#module_input_ModuleMargin_Right'
    },
    events: {
        'click #eventApp_btn01': 'onBtn01',
        'click #eventApp_btn02': 'onBtn02'
    },
    onRender: function () {


        
        this.setupEnableType();
        

        
    },
    onAttach() {
        var self = this;

        //this.setupSelect();
        this.setupMenuItem01();
        this.setupMenuItem02();
        this.setupMenuItem03();
        this.setupMenuItem04();
        this.setupMenuItem05();

        this.ui.eventApp_input_Duration_01.durationPicker({
            translations: {
                day: resources.X101498,
                hour: resources.X101499,
                minute: resources.X101500,
                second: resources.X101501,
                days: resources.X101502,
                hours: resources.X101503,
                minutes: resources.X101504,
                seconds: resources.X101505,
            },
            showSeconds: true,
            onChanged: function (newVal) {
                self.ui.eventApp_label_Duration_01.text(newVal);
                self.model.set({
                    Duration01: newVal
                });
            }
        });
        this.ui.eventApp_group_Duration_01.find('.input-sm').width(90);

        this.ui.eventApp_input_Duration_02.durationPicker({
            translations: {
                day: resources.X101498,
                hour: resources.X101499,
                minute: resources.X101500,
                second: resources.X101501,
                days: resources.X101502,
                hours: resources.X101503,
                minutes: resources.X101504,
                seconds: resources.X101505,
            },
            showSeconds: true,
            onChanged: function (newVal) {
                self.ui.eventApp_label_Duration_02.text(newVal);
                self.model.set({
                    Duration02: newVal
                });
            }
        });
        this.ui.eventApp_group_Duration_02.find('.input-sm').width(90);

        this.ui.eventApp_input_Duration_03.durationPicker({
            translations: {
                day: resources.X101498,
                hour: resources.X101499,
                minute: resources.X101500,
                second: resources.X101501,
                days: resources.X101502,
                hours: resources.X101503,
                minutes: resources.X101504,
                seconds: resources.X101505,
            },
            showSeconds: true,
            onChanged: function (newVal) {
                self.ui.eventApp_label_Duration_03.text(newVal);
                self.model.set({
                    Duration03: newVal
                });
            }
        });
        this.ui.eventApp_group_Duration_03.find('.input-sm').width(90);

        this.ui.eventApp_input_Duration_04.durationPicker({
            translations: {
                day: resources.X101498,
                hour: resources.X101499,
                minute: resources.X101500,
                second: resources.X101501,
                days: resources.X101502,
                hours: resources.X101503,
                minutes: resources.X101504,
                seconds: resources.X101505,
            },
            showSeconds: true,
            onChanged: function (newVal) {
                self.ui.eventApp_label_Duration_04.text(newVal);
                self.model.set({
                    Duration04: newVal
                });
            }
        });
        this.ui.eventApp_group_Duration_04.find('.input-sm').width(90);

        this.ui.eventApp_input_Duration_05.durationPicker({
            translations: {
                day: resources.X101498,
                hour: resources.X101499,
                minute: resources.X101500,
                second: resources.X101501,
                days: resources.X101502,
                hours: resources.X101503,
                minutes: resources.X101504,
                seconds: resources.X101505,
            },
            showSeconds: true,
            onChanged: function (newVal) {
                self.ui.eventApp_label_Duration_05.text(newVal);
                self.model.set({
                    Duration05: newVal
                });
            }
        });
        this.ui.eventApp_group_Duration_05.find('.input-sm').width(90);


        $('.bdp-block.hidden').css('display', 'none');

        


        
    },
    setupMenuItem01: function () {
        var self = this;

        var customEvent = self.app.entities.collections.customEvent.fullCollection.where({ id: this.options.parent.options.templateModel.attributes.EventId })[0];

        this.ui.menuSingle_dropDown_MenuItem_01.empty();

        if (this.model.attributes.MenuItem01 == 0) {
            var options = String.format('<option value="{1}" {2}>{0}</option>', resources.X100292, 0, 'selected = "selected"');
            self.ui.menuSingle_dropDown_MenuItem_01.append(options);
        }
        else {
            var options = String.format('<option value="{1}" {2}>{0}</option>', resources.X100292, 0, '');
            self.ui.menuSingle_dropDown_MenuItem_01.append(options);
        }

        if (self.InfoPageSetting.attributes.EnableWindowPage) {
            if (this.model.attributes.MenuItem01 == 99999) {
                var options = String.format('<option value="{1}" {2}>{0}</option>', resources.X101483, 99999, 'selected = "selected"');
                self.ui.menuSingle_dropDown_MenuItem_01.append(options);
            }
            else {
                var options = String.format('<option value="{1}" {2}>{0}</option>', resources.X101483, 99999, '');
                self.ui.menuSingle_dropDown_MenuItem_01.append(options);
            }
        }

        var selected = '';



        this.menuItemCollection.forEach(function (entry) {
            if (entry.attributes.Tag == 1 || entry.attributes.Tag == 5 || entry.attributes.Tag == 7 || entry.attributes.Tag == 11) {

                if (entry.attributes.Tag == 5 && customEvent.attributes.Module_SchemaModel == 0) return;
                if (entry.attributes.Tag == 7 && customEvent.attributes.Module_FormModel == 0) return;

                selected = '';
                if (self.model.attributes.MenuItem01 == entry.attributes.id) {
                    selected = 'selected = "selected"';
                }
                var options = String.format('<option value="{1}" {2}>{0}</option>', entry.attributes.Name, entry.attributes.id, selected);
                self.ui.menuSingle_dropDown_MenuItem_01.append(options);
            }
        });
    },
    setupMenuItem02: function () {
        var self = this;

        var customEvent = self.app.entities.collections.customEvent.fullCollection.where({ id: this.options.parent.options.templateModel.attributes.EventId })[0];

        this.ui.menuSingle_dropDown_MenuItem_02.empty();

        if (this.model.attributes.MenuItem02 == 0) {
            var options = String.format('<option value="{1}" {2}>{0}</option>', resources.X100292, 0, 'selected = "selected"');
            self.ui.menuSingle_dropDown_MenuItem_02.append(options);
        }
        else {
            var options = String.format('<option value="{1}" {2}>{0}</option>', resources.X100292, 0, '');
            self.ui.menuSingle_dropDown_MenuItem_02.append(options);
        }

        if (self.InfoPageSetting.attributes.EnableWindowPage) {
            if (this.model.attributes.MenuItem02 == 99999) {
                var options = String.format('<option value="{1}" {2}>{0}</option>', resources.X101483, 99999, 'selected = "selected"');
                self.ui.menuSingle_dropDown_MenuItem_02.append(options);
            }
            else {
                var options = String.format('<option value="{1}" {2}>{0}</option>', resources.X101483, 99999, '');
                self.ui.menuSingle_dropDown_MenuItem_02.append(options);
            }
        }

        var selected = '';



        this.menuItemCollection.forEach(function (entry) {
            if (entry.attributes.Tag == 1 || entry.attributes.Tag == 5 || entry.attributes.Tag == 7 || entry.attributes.Tag == 11) {

                if (entry.attributes.Tag == 5 && customEvent.attributes.Module_SchemaModel == 0) return;
                if (entry.attributes.Tag == 7 && customEvent.attributes.Module_FormModel == 0) return;

                selected = '';
                if (self.model.attributes.MenuItem02 == entry.attributes.id) {
                    selected = 'selected = "selected"';
                }
                var options = String.format('<option value="{1}" {2}>{0}</option>', entry.attributes.Name, entry.attributes.id, selected);
                self.ui.menuSingle_dropDown_MenuItem_02.append(options);
            }
        });
    },
    setupMenuItem03: function () {
        var self = this;

        var customEvent = self.app.entities.collections.customEvent.fullCollection.where({ id: this.options.parent.options.templateModel.attributes.EventId })[0];

        this.ui.menuSingle_dropDown_MenuItem_03.empty();

        if (this.model.attributes.MenuItem03 == 0) {
            var options = String.format('<option value="{1}" {2}>{0}</option>', resources.X100292, 0, 'selected = "selected"');
            self.ui.menuSingle_dropDown_MenuItem_03.append(options);
        }
        else {
            var options = String.format('<option value="{1}" {2}>{0}</option>', resources.X100292, 0, '');
            self.ui.menuSingle_dropDown_MenuItem_03.append(options);
        }

        if (self.InfoPageSetting.attributes.EnableWindowPage) {
            if (this.model.attributes.MenuItem03 == 99999) {
                var options = String.format('<option value="{1}" {2}>{0}</option>', resources.X101483, 99999, 'selected = "selected"');
                self.ui.menuSingle_dropDown_MenuItem_03.append(options);
            }
            else {
                var options = String.format('<option value="{1}" {2}>{0}</option>', resources.X101483, 99999, '');
                self.ui.menuSingle_dropDown_MenuItem_03.append(options);
            }
        }

        var selected = '';



        this.menuItemCollection.forEach(function (entry) {
            if (entry.attributes.Tag == 1 || entry.attributes.Tag == 5 || entry.attributes.Tag == 7 || entry.attributes.Tag == 11) {

                if (entry.attributes.Tag == 5 && customEvent.attributes.Module_SchemaModel == 0) return;
                if (entry.attributes.Tag == 7 && customEvent.attributes.Module_FormModel == 0) return;

                selected = '';
                if (self.model.attributes.MenuItem03 == entry.attributes.id) {
                    selected = 'selected = "selected"';
                }
                var options = String.format('<option value="{1}" {2}>{0}</option>', entry.attributes.Name, entry.attributes.id, selected);
                self.ui.menuSingle_dropDown_MenuItem_03.append(options);
            }
        });
    },
    setupMenuItem04: function () {
        var self = this;

        var customEvent = self.app.entities.collections.customEvent.fullCollection.where({ id: this.options.parent.options.templateModel.attributes.EventId })[0];

        this.ui.menuSingle_dropDown_MenuItem_04.empty();

        if (this.model.attributes.MenuItem04 == 0) {
            var options = String.format('<option value="{1}" {2}>{0}</option>', resources.X100292, 0, 'selected = "selected"');
            self.ui.menuSingle_dropDown_MenuItem_04.append(options);
        }
        else {
            var options = String.format('<option value="{1}" {2}>{0}</option>', resources.X100292, 0, '');
            self.ui.menuSingle_dropDown_MenuItem_04.append(options);
        }

        if (self.InfoPageSetting.attributes.EnableWindowPage) {
            if (this.model.attributes.MenuItem04 == 99999) {
                var options = String.format('<option value="{1}" {2}>{0}</option>', resources.X101483, 99999, 'selected = "selected"');
                self.ui.menuSingle_dropDown_MenuItem_04.append(options);
            }
            else {
                var options = String.format('<option value="{1}" {2}>{0}</option>', resources.X101483, 99999, '');
                self.ui.menuSingle_dropDown_MenuItem_04.append(options);
            }
        }

        var selected = '';



        this.menuItemCollection.forEach(function (entry) {
            if (entry.attributes.Tag == 1 || entry.attributes.Tag == 5 || entry.attributes.Tag == 7 || entry.attributes.Tag == 11) {

                if (entry.attributes.Tag == 5 && customEvent.attributes.Module_SchemaModel == 0) return;
                if (entry.attributes.Tag == 7 && customEvent.attributes.Module_FormModel == 0) return;

                selected = '';
                if (self.model.attributes.MenuItem04 == entry.attributes.id) {
                    selected = 'selected = "selected"';
                }
                var options = String.format('<option value="{1}" {2}>{0}</option>', entry.attributes.Name, entry.attributes.id, selected);
                self.ui.menuSingle_dropDown_MenuItem_04.append(options);
            }
        });
    },
    setupMenuItem05: function () {
        var self = this;

        var customEvent = self.app.entities.collections.customEvent.fullCollection.where({ id: this.options.parent.options.templateModel.attributes.EventId })[0];

        this.ui.menuSingle_dropDown_MenuItem_05.empty();

        if (this.model.attributes.MenuItem05 == 0) {
            var options = String.format('<option value="{1}" {2}>{0}</option>', resources.X100292, 0, 'selected = "selected"');
            self.ui.menuSingle_dropDown_MenuItem_05.append(options);
        }
        else {
            var options = String.format('<option value="{1}" {2}>{0}</option>', resources.X100292, 0, '');
            self.ui.menuSingle_dropDown_MenuItem_05.append(options);
        }

        if (self.InfoPageSetting.attributes.EnableWindowPage) {
            if (this.model.attributes.MenuItem05 == 99999) {
                var options = String.format('<option value="{1}" {2}>{0}</option>', resources.X101483, 99999, 'selected = "selected"');
                self.ui.menuSingle_dropDown_MenuItem_05.append(options);
            }
            else {
                var options = String.format('<option value="{1}" {2}>{0}</option>', resources.X101483, 99999, '');
                self.ui.menuSingle_dropDown_MenuItem_05.append(options);
            }
        }

        var selected = '';



        this.menuItemCollection.forEach(function (entry) {
            if (entry.attributes.Tag == 1 || entry.attributes.Tag == 5 || entry.attributes.Tag == 7 || entry.attributes.Tag == 11) {

                if (entry.attributes.Tag == 5 && customEvent.attributes.Module_SchemaModel == 0) return;
                if (entry.attributes.Tag == 7 && customEvent.attributes.Module_FormModel == 0) return;

                selected = '';
                if (self.model.attributes.MenuItem05 == entry.attributes.id) {
                    selected = 'selected = "selected"';
                }
                var options = String.format('<option value="{1}" {2}>{0}</option>', entry.attributes.Name, entry.attributes.id, selected);
                self.ui.menuSingle_dropDown_MenuItem_05.append(options);
            }
        });
    },
    setupSelect: function () {
        var self = this;
        var customEvent = app.entities.collections.customEvent.where({ id: this.options.parent.options.templateModel.attributes.EventId })[0];

        var item = this.menuItemCollection.where({ Tag: 1 })[0];
        if (self.model.attributes.MenuItem01 == -1) {
            self.model.attributes.MenuItem01 = item.attributes.id;
        }
        if (self.model.attributes.MenuItem02 == -1) {
            self.model.attributes.MenuItem02 = item.attributes.id;
        }
        if (self.model.attributes.MenuItem03 == -1) {
            self.model.attributes.MenuItem03 = item.attributes.id;
        }
        if (self.model.attributes.MenuItem04 == -1) {
            self.model.attributes.MenuItem04 = item.attributes.id;
        }
        if (self.model.attributes.MenuItem05 == -1) {
            self.model.attributes.MenuItem05 = item.attributes.id;
        }

        this.ui.eventApp_dropDown_MenuItem_01.empty();
        //self.ui.eventApp_dropDown_MenuItem_02.empty();
        self.ui.eventApp_dropDown_MenuItem_03.empty();
        self.ui.eventApp_dropDown_MenuItem_04.empty();
        self.ui.eventApp_dropDown_MenuItem_05.empty();

        this.menuItemCollection.forEach(function (entry) {
            if (entry.attributes.Tag == 1 || entry.attributes.Tag == 5 || entry.attributes.Tag == 7 || entry.attributes.Tag == 11) {

                if (entry.attributes.Tag == 5 && customEvent.attributes.Module_SchemaModel == 0) return;
                if (entry.attributes.Tag == 7 && customEvent.attributes.Module_FormModel == 0) return;

                var selected = '';
                if (self.model.attributes.MenuItem01 == entry.attributes.id) {
                    selected = 'selected = "selected"';
                }
                var options = String.format('<option value="{1}" {2}>{0}</option>', entry.attributes.Name, entry.attributes.id, selected);
                self.ui.eventApp_dropDown_MenuItem_01.append(options);
            }
        });

        this.menuItemCollection.forEach(function (entry) {
            if (entry.attributes.Tag == 1 || entry.attributes.Tag == 5 || entry.attributes.Tag == 7 || entry.attributes.Tag == 11) {

                if (entry.attributes.Tag == 5 && customEvent.attributes.Module_SchemaModel == 0) return;
                if (entry.attributes.Tag == 7 && customEvent.attributes.Module_FormModel == 0) return;

                var selected = '';
                if (self.model.attributes.MenuItem02 == entry.attributes.id) {
                    selected = 'selected = "selected"';
                }
                var options = String.format('<option value="{1}" {2}>{0}</option>', entry.attributes.Name, entry.attributes.id, selected);
                self.ui.eventApp_dropDown_MenuItem_02.append(options);
            }
        });

        this.menuItemCollection.forEach(function (entry) {
            if (entry.attributes.Tag == 1 || entry.attributes.Tag == 5 || entry.attributes.Tag == 7 || entry.attributes.Tag == 11) {

                if (entry.attributes.Tag == 5 && customEvent.attributes.Module_SchemaModel == 0) return;
                if (entry.attributes.Tag == 7 && customEvent.attributes.Module_FormModel == 0) return;

                var selected = '';
                if (self.model.attributes.MenuItem03 == entry.attributes.id) {
                    selected = 'selected = "selected"';
                }
                var options = String.format('<option value="{1}" {2}>{0}</option>', entry.attributes.Name, entry.attributes.id, selected);
                self.ui.eventApp_dropDown_MenuItem_03.append(options);
            }
        });

        this.menuItemCollection.forEach(function (entry) {
            if (entry.attributes.Tag == 1 || entry.attributes.Tag == 5 || entry.attributes.Tag == 7 || entry.attributes.Tag == 11) {

                if (entry.attributes.Tag == 5 && customEvent.attributes.Module_SchemaModel == 0) return;
                if (entry.attributes.Tag == 7 && customEvent.attributes.Module_FormModel == 0) return;

                var selected = '';
                if (self.model.attributes.MenuItem04 == entry.attributes.id) {
                    selected = 'selected = "selected"';
                }
                var options = String.format('<option value="{1}" {2}>{0}</option>', entry.attributes.Name, entry.attributes.id, selected);
                self.ui.eventApp_dropDown_MenuItem_04.append(options);
            }
        });

        this.menuItemCollection.forEach(function (entry) {
            if (entry.attributes.Tag == 1 || entry.attributes.Tag == 5 || entry.attributes.Tag == 7 || entry.attributes.Tag == 11) {

                if (entry.attributes.Tag == 5 && customEvent.attributes.Module_SchemaModel == 0) return;
                if (entry.attributes.Tag == 7 && customEvent.attributes.Module_FormModel == 0) return;

                var selected = '';
                if (self.model.attributes.MenuItem05 == entry.attributes.id) {
                    selected = 'selected = "selected"';
                }
                var options = String.format('<option value="{1}" {2}>{0}</option>', entry.attributes.Name, entry.attributes.id, selected);
                self.ui.eventApp_dropDown_MenuItem_05.append(options);
            }
        });
    },
    setupEnableType: function () {
        var checked = this.model.attributes.EnablePlay == 1 ? true : false;
        this.ui.eventApp_checkbox_EnablePlay.attr('checked', checked);
    },
    onBtn01: function () {
        var self = this;

        self.setModel();

        var callback = function () {
            self.trigger("dialog:close");
            self.triggerMethod('dialog:btn01clicked', "msg");
        }

        this.validate(callback);
    },
    onBtn02: function () {
        this.triggerMethod('dialog:btn02clicked', "msg");
        this.trigger("dialog:close");
    },
    showErrors: function (errors) {
        _.each(errors, function (error) {
            var controlGroup = this.$('.' + error.name);
            controlGroup.addClass('error');
            controlGroup.find('.help-inline').text(error.message);
        }, this);
    },
    hideErrors: function () {
        this.$('.control-group').removeClass('error');
        this.$('.help-inline').text('');

        this.errors = [];
    },
    validate: function (callback) {
        var self = this;
        this.hideErrors();
        callback();
    },
    setModel: function () {
        var EnablePlay = this.model.attributes.EnablePlay;
        this.ui.eventApp_checkbox_EnablePlay.is(':checked') ? EnablePlay = 1 : EnablePlay = 0;

        this.model.set({
            EnablePlay: EnablePlay,
            MenuItem01: this.ui.menuSingle_dropDown_MenuItem_01.val(),
            MenuItem02: this.ui.menuSingle_dropDown_MenuItem_02.val(),
            MenuItem03: this.ui.menuSingle_dropDown_MenuItem_03.val(),
            MenuItem04: this.ui.menuSingle_dropDown_MenuItem_04.val(),
            MenuItem05: this.ui.menuSingle_dropDown_MenuItem_05.val(),
            ModuleMargin_Top: this.ui.module_input_ModuleMargin_Top.val(),
            ModuleMargin_Bottom: this.ui.module_input_ModuleMargin_Bottom.val(),
            ModuleMargin_Left: this.ui.module_input_ModuleMargin_Left.val(),
            ModuleMargin_Right: this.ui.module_input_ModuleMargin_Right.val()
        });
    }
});